import { gql } from '@apollo/client';

export const VALIDATE_ACCOUNT = gql`
  query Query($accountNumber: String, $postcode: String) {
    customerAccountWebsite(accountNumber: $accountNumber, postcode: $postcode) {
      id
      accountId
      fuel
      utilityAddress {
        state
      }
      dormant
      paymentMethod
    }
  }
`;
